import { render } from "./MessageCartReviewPage.vue?vue&type=template&id=546fcf17"
import script from "./MessageCartReviewPage.vue?vue&type=script&lang=js"
export * from "./MessageCartReviewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__